const ConfigParam = {
  btn_google_signin_dark_normal_web: 'https://d2atdwxjx7uc4i.cloudfront.net/images/google.svg',
  contFacebook: 'https://d2atdwxjx7uc4i.cloudfront.net/images/facebook.svg',
  twitter_button: 'https://d2atdwxjx7uc4i.cloudfront.net/images/x3.svg',
  microsoft_button: 'https://d2atdwxjx7uc4i.cloudfront.net/images/ms-symbollockup_signin_dark.svg',
  linkedin_button: 'https://d2atdwxjx7uc4i.cloudfront.net/images/Sign-In-Large---Default.png',
}
export default ConfigParam
